import React from 'react';
import { Star, X, Save } from 'lucide-react';

const INPUT = 'border border-earth/15 rounded-md px-3 py-2 text-sm font-sans text-earth-dark focus:ring-2 focus:ring-saffron/30 focus:border-saffron focus:outline-none bg-white';
const TEXT_FIELDS = [
  { key: 'name', placeholder: 'Buyer Name' },
  { key: 'company', placeholder: 'Company Name' },
  { key: 'country', placeholder: 'Country' },
];

function RatingPicker({ value, onChange }) {
  return (
    <div className="flex items-center gap-1">
      <span className="text-xs text-earth/50 font-sans mr-1">Rating:</span>
      {[1, 2, 3, 4, 5].map(s => (
        <button key={s} onClick={() => onChange(s)} data-testid={`rating-${s}`}>
          <Star size={16} className={s <= value ? 'text-saffron fill-saffron' : 'text-earth/20'} />
        </button>
      ))}
    </div>
  );
}

export default function TestimonialForm({ form, setForm, isEditing, onSave, onCancel }) {
  const setField = (key, value) => setForm(f => ({ ...f, [key]: value }));
  return (
    <div className="bg-white rounded-lg border border-saffron-100/50 shadow-card-lift p-5" data-testid="testimonial-form">
      <h3 className="font-display text-sm font-bold text-earth-dark mb-4">{isEditing ? 'Edit Testimonial' : 'Add New Testimonial'}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-3">
        {TEXT_FIELDS.map(f => (
          <input key={f.key} value={form[f.key]} onChange={e => setField(f.key, e.target.value)} placeholder={f.placeholder} className={INPUT} data-testid={`testimonial-${f.key}`} />
        ))}
      </div>
      <textarea value={form.text} onChange={e => setField('text', e.target.value)} placeholder="Testimonial text..." rows={3} className={`w-full mb-3 ${INPUT}`} data-testid="testimonial-text" />
      <div className="flex items-center gap-4">
        <RatingPicker value={form.rating} onChange={s => setField('rating', s)} />
        <label className="flex items-center gap-1.5 cursor-pointer">
          <input type="checkbox" checked={form.published} onChange={e => setField('published', e.target.checked)} className="rounded border-earth/30 text-saffron focus:ring-saffron" data-testid="testimonial-published" />
          <span className="text-xs text-earth/50 font-sans">Published</span>
        </label>
        <div className="flex-1" />
        {isEditing && (
          <button onClick={onCancel} className="text-xs text-earth/40 font-sans hover:text-earth" data-testid="cancel-edit">
            <X size={14} /> Cancel
          </button>
        )}
        <button onClick={onSave} disabled={!form.name || !form.text} className="flex items-center gap-1.5 bg-saffron text-white font-sans font-semibold text-xs px-4 py-2 rounded-md hover:bg-saffron-dark transition-colors disabled:opacity-40" data-testid="save-testimonial">
          <Save size={12} /> {isEditing ? 'Update' : 'Add'}
        </button>
      </div>
    </div>
  );
}
